import Swal from "sweetalert2";
import type { TFunction } from "i18next";

/**
 * Aviso de que el controlador está ocupado y se reintenta el comando de pluma
 * (ver store/oasis/doorBusyRetry.ts). Toast y no modal: el reintento puede
 * durar hasta 2 min, y un modal bloqueante le impedía al vigilante registrar
 * la siguiente unidad de la fila. El texto no dice "abrir" (también se usa para
 * cerrar) ni "historial": "SDK busy" no dice qué ocupa el semáforo.
 */
export const showDoorWaitingToast = (t: TFunction, attempt: number) => {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: "info",
    title: t("access.messages.doorWaitingTitle"),
    text: t("access.messages.doorWaitingText", { attempt }),
    showConfirmButton: false,
    timer: 12000,
  });
};
